import { createSlice, type PayloadAction } from '@reduxjs/toolkit'

export interface DeviceInfo {
  id: string
  name: string
  serial_number: string
  device_type_id: string
  device_type: string
  asset_model_id?: string
  asset_model_name?: string
  device_model_id: string
  device_model_name: string
  comm_type: string
  rem_bat_percent: string
  comm_mod_serial: string
  asset_state: string
  latitude: string
  longitude: string
  install_date: string
  removal_date: string
  gateway_id: string
  firmware_version: string
  ip_address: string
  port: string
  description: string
  application_type: string
  asset_category_id: string
  site_id: string
  asset_category_name: string
  communication_status: string
  hierarchy: string
  slave_id: number
  parent_asset_id: string
}

export interface DeviceInfoState {
  isLoading: boolean
  loadingError: string | null
  deviceInfo: DeviceInfo | null
  httpStatus: number | null
}

export const initialState: DeviceInfoState = {
  isLoading: true,
  loadingError: null,
  deviceInfo: null,
  httpStatus: null
}

const deviceInfoSlice = createSlice({
  name: 'deviceManagementDeviceInfo',
  initialState,
  reducers: {
    deviceInfoLoadingAction: (state) => {
      return {
        isLoading: true,
        loadingError: null,
        deviceInfo: null,
        httpStatus: 0
      }
    },
    deviceInfoUpdateAction: (state, action: PayloadAction<{ data: DeviceInfo, httpStatus: number }>) => {
      return {
        isLoading: false,
        loadingError: null,
        deviceInfo: action.payload.data,
        httpStatus: action.payload.httpStatus
      }
    },
    deviceInfoErrorAction: (state, action: PayloadAction<{ errorMessage: string, httpStatus: number }>) => {
      return {
        isLoading: false,
        loadingError: action.payload.errorMessage,
        deviceInfo: null,
        httpStatus: action.payload.httpStatus
      }
    }
  }
})

export const {
  deviceInfoLoadingAction,
  deviceInfoUpdateAction,
  deviceInfoErrorAction
} = deviceInfoSlice.actions

export default deviceInfoSlice.reducer
